import { useState } from 'react';
import MaterialView from './MaterialView';
import MaterialEdit from './MaterialEdit';
import { Material } from 'components/IAP/hooks/useSafetyAnalysis';

const MaterialContainer: React.FC<{
  singleMaterial: Material;
  updateMaterial: (singleMaterial: Material) => void;
  deleteMaterial: (materialId: string) => void;
  readOnly?: boolean;
}> = ({ singleMaterial, updateMaterial, deleteMaterial, readOnly = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  return isEditing && !readOnly ? (
    <MaterialEdit
      singleMaterial={singleMaterial}
      setIsEditing={(choice) => setIsEditing(choice)}
      updateMaterial={updateMaterial}
    />
  ) : (
    <MaterialView
      singleMaterial={singleMaterial}
      setIsEditing={(choice) => setIsEditing(choice)}
      deleteMaterial={(materialId) => deleteMaterial(materialId)}
      readOnly={readOnly}
    />
  );
};

export default MaterialContainer;
